import { render, staticRenderFns } from "./accessNew.vue?vue&type=template&id=216173fe&scoped=true"
import script from "./accessNew.vue?vue&type=script&lang=js"
export * from "./accessNew.vue?vue&type=script&lang=js"
import style0 from "./accessNew.vue?vue&type=style&index=0&id=216173fe&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216173fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('216173fe')) {
      api.createRecord('216173fe', component.options)
    } else {
      api.reload('216173fe', component.options)
    }
    module.hot.accept("./accessNew.vue?vue&type=template&id=216173fe&scoped=true", function () {
      api.rerender('216173fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dataAccess/deviceAccess/accessNew.vue"
export default component.exports